// extracted by mini-css-extract-plugin
module.exports = {"mailTo":"_3KNvqiJ9"};